import {
  Box,
  Button, Container,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getUserData as getUser } from '../../../../Redux/Models/user';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';

export default function SubscriptionSuccess({ classes }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentUser = getUserData();
  const [searchParams] = useSearchParams();

  const planType = searchParams.get('planType');

  useEffect(() => {
    if (!planType) {
      navigate(ROUTES.subscription());
    } else {
      dispatch(getUser(currentUser.id));
    }
  }, [planType]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <Container className="center">
          <img src={Images.Logo} alt="box pack" className="mt-4" />

          <Box my={8}>
            <img src={Images.PremiumStar} alt="thank you" width="160" height="160" />
          </Box>

          <div className="s-16 weight-700 height-14">
            Thank you for subscribing!
          </div>

          <div className="s-14 height-14 weight-400 mt-2">
            Your
            {' '}
            {planType}
            {' '}
            subscription package is now active.
            <br />
            Let&apos;s start saved and explore valuable wine
            <br />
            with Oeno Bank!
          </div>
        </Container>

        <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth onClick={() => window.location.replace('/')}>Let&apos;s go</Button>
          </Container>
        </div>
      </div>
    </Elements.PageBase>
  );
}
